import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/vipImg/renewal_course_1.png'
import _imports_1 from '@/assets/image/vipImg/renewal_course_2.png'
import _imports_2 from '@/assets/image/vipImg/renewal_course_3.png'
import _imports_3 from '@/assets/image/vipImg/renewal_course_4.png'


const _withScopeId = n => (_pushScopeId("data-v-34406664"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "RenewalCourse" }
const _hoisted_2 = {
  key: 0,
  class: "wrap flex ter cen"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content flex ter cen" }, [
  /*#__PURE__*/_createElementVNode("p", null, " 1）マイペイパルにログイン後、画面右上の歯車のアイコン（個人設定）をクリックします。 "),
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("p", null, "2）画面上部の［支払い］をクリックします。"),
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("p", null, "3）［自動支払いを管理する］ボタンをクリックします。"),
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
  /*#__PURE__*/_createElementVNode("p", null, "4）こちらの画面で、定期決済の追加・キャンセルが行えます。キャンセルする場合は、左側のメニューから、キャンセルしたい定期決済をクリックし、右側の画面の［キャンセル］ボタンをクリックします。"),
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
], -1))
const _hoisted_4 = {
  key: 1,
  class: "wrap flex ter cen"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<h2 data-v-34406664>How to cancle paypal automatic payment</h2><div class=\"content flex ter cen\" data-v-34406664><p data-v-34406664> 1)After logging in to My PayPal, click the gear icon in the upper right corner of the screen (personal settings) </p><img src=\"https://static-s.theckb.com/BusinessMarket/Client/paypal/paypal_en_1.png\" data-v-34406664><p data-v-34406664>2) Click &quot;Payments&quot; at the top of the screen.</p><img src=\"https://static-s.theckb.com/BusinessMarket/Client/paypal/paypal_en_2.png\" data-v-34406664><p data-v-34406664>3)Click the Automatic Payments Manage button.</p><img src=\"https://static-s.theckb.com/BusinessMarket/Client/paypal/paypal_en_3.png\" data-v-34406664><p data-v-34406664>4)You can add or cancel recurring payments on this screen. To cancel, click the recurring payment you want to cancel from the left menu, and then click the [Cancel] button on the right screen.</p><img src=\"https://static-s.theckb.com/BusinessMarket/Client/paypal/paypal_en_4.png\" data-v-34406664></div>", 2)
const _hoisted_7 = [
  _hoisted_5
]

import { t } from '@/plugins/i18n'
import { isKO, isJA, isEN } from '@/store'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isJA)())
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h2", null, _toDisplayString(_unref(t)('关闭paypal自动续费教程')), 1),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    (_unref(isEN)())
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
      : _createCommentVNode("", true)
  ]))
}
}

})